import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import { catMeta, CATEGORY_HERO } from "../lib/categories";

export default function CategoryTiles() {
  const [cats, setCats] = useState(null);
  useEffect(() => {
    api.get("/categories").then(({ data }) => setCats(Array.isArray(data) ? data.slice(0, 8) : [])).catch(() => setCats([]));
  }, []);
  if (!cats || cats.length === 0) return null;

  return (
    <section className="py-20 bg-[#0d1626]" data-testid="category-tiles-section">
      <div className="max-w-5xl mx-auto px-6">
        <p className="text-[#2ec9c9] font-semibold tracking-wide uppercase text-sm">Explore</p>
        <h2 className="text-3xl sm:text-4xl font-bold text-white mt-2 mb-8">Browse by category</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {cats.map((c) => {
            const cm = catMeta(c); const Icon = cm.icon; const hero = CATEGORY_HERO[c];
            return (
              <Link key={c} to={`/events/category/${encodeURIComponent(c)}`} data-testid={`category-tile-${c}`}
                className="group relative h-32 sm:h-36 rounded-2xl overflow-hidden border border-white/10 hover:border-[#2ec9c9]/50 transition-colors">
                {hero && <img src={hero} alt={c} className="absolute inset-0 w-full h-full object-cover opacity-45 group-hover:opacity-60 group-hover:scale-105 transition-all duration-500" />}
                <div className="absolute inset-0" style={{ background: `linear-gradient(135deg, #0d1626cc, ${cm.color}44)` }} />
                <div className="relative h-full p-4 flex flex-col justify-between">
                  <span className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: cm.color + "40", color: "#fff" }}><Icon size={18} /></span>
                  <span className="text-white font-semibold text-lg">{c}</span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
